module.exports = __webpack_public_path__ + "img/comment-lines.1885f34d.svg";